export default __webpack_public_path__ + "static/media/Axe.24634ff7.png";